import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ListRepositoriesResponse } from '@xver/apis/v1/sammeln/repositories/model';

export const REPOSITORIES_QUERY_KEY = 'apis.v1.sammeln.repositories.list';

export function useRepositoriesQuery(projectIdOrName: string) {
    return useQuery<ListRepositoriesResponse>({
        queryKey: [REPOSITORIES_QUERY_KEY, projectIdOrName],
        queryFn: () => Endpoints.v1.Sammeln.Repositories.listRepositories(projectIdOrName),
        enabled: !!projectIdOrName,
        refetchInterval: 10000,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
        retry: (count, err) => {
            const status = (err as { status?: number } | null)?.status ?? 0;
            return status < 400 && count < 2;
        },
    });
}
